import type { StaffGrant } from "./api";

export const key = (g: StaffGrant) => `${g.module}:${g.action}`;

export function grantsFromSet(selected: Set<string>): StaffGrant[] {
  return [...selected].map((k) => {
    const [module, action] = k.split(":");
    return { module: module ?? "", action: action ?? "" };
  });
}
